module.exports = {
    "postbox-text": "Escribe tu comentario aquí (al menos 3 caracteres)",
    "postbox-author": "Nombre (opcional)",
    "postbox-author-placeholder": "John Doe",
    "postbox-email": "Correo electrónico (opcional)",
    "postbox-email-placeholder": "johndoe@example.com",
    "postbox-website": "Página web (opcional)",
    "postbox-website-placeholder": "https://example.com",
    "postbox-preview": "Vista previa",
    "postbox-edit": "Editar",
    "postbox-submit": "Enviar",
    "postbox-notification": "Suscríbete a las notificaciones por correo electrónico",

    "num-comments": "Un comentario\n{{ n }} comentarios",
    "no-comments": "Aún no hay comentarios",
    "atom-feed": "Fuente web Atom",

    "comment-reply": "Responder",
    "comment-edit": "Editar",
    "comment-save": "Guardar",
    "comment-delete": "Eliminar",
    "comment-confirm": "Confirmar",
    "comment-close": "Cerrar",
    "comment-cancel": "Cancelar",
    "comment-deleted": "Comentario eliminado.",
    "comment-queued": "Comentario pendiente de moderación.",
    "comment-anonymous": "Anónimo",
    "comment-hidden": "1 oculto\n{{ n }} ocultos",
    "comment-page-author-suffix": "Autor",

    "date-now": "ahora",
    "date-minute": "hace un minuto\nhace {{ n }} minutos",
    "date-hour": "hace una hora\nhace {{ n }} horas",
    "date-day": "ayer\nhace {{ n }} días",
    "date-week": "la semana pasada\nhace {{ n }} semanas",
    "date-month": "el mes pasado\nhace {{ n }} meses",
    "date-year": "el año pasado\nhace {{ n }} años"
};
